<template>
  <v-container fluid>
    <v-row dense row>
      <v-col>
        <h2 class="text-center">Headlines</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pl-0">
        <AnalysisList
          :additional-params="params"
          no-data-text="No headlines found"
        ></AnalysisList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { RISK_RATING_SUB } from "@/common/constants/controlRisks/risks";

export default {
  name: "GrdHomeHeadlines",
  components: {
    AnalysisList: () => import("@/components/analysis/AnalysisList"),
  },
  data: () => ({
    params: {
      riskCategories: RISK_RATING_SUB.kidnap,
    },
  }),
};
</script>

<style scoped></style>
